<template>
  <v-container fluid grid-list-lg>
    <v-layout>
      <v-flex>
        <h1 class="display-3">Solicitud de productos</h1>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <v-container flex grid-list-sm>
              <v-layout wrap align-center justify-center>
                <v-flex class="text-xs-right">
                  <v-btn color="green" dark @click.stop="crudAdd()">
                    Agregar
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="items"
            :pagination.sync="pag"
            :total-items="totalItems"
            :loading="loading"
            rows-per-page-text="Filas por pagina"
            no-data-text="No hay datos"
            disable-initial-sort
            item-key="id"
            class="tabla-compacta-col"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.id }}</td>
              <td class="text-xs-center">
                {{ props.item.tipo ? props.item.tipo.desig : "" }}
              </td>
              <td class="text-xs-center">{{ props.item.descripcion }}</td>
              <td class="text-xs-center">{{ props.item.um }}</td>
              <td class="text-xs-center">{{ props.item.ancho }}</td>
              <td class="text-xs-center">
                <div v-if="props.item.micro_id_1">
                  FRIOLATINA: {{ props.item.micro_id_1 }}
                </div>
                <div v-if="props.item.micro_id_2">
                  BERVILL: {{ props.item.micro_id_2 }}
                </div>
                <div v-if="props.item.micro_id_3">
                  ACEROLATINA: {{ props.item.micro_id_3 }}
                </div>
              </td>
              <td class="text-xs-center">
                <div v-if="props.item.micro_familia_1">
                  FRIOLATINA: {{ props.item.micro_familia_1 }}
                </div>
                <div v-if="props.item.micro_familia_2">
                  BERVILL: {{ props.item.micro_familia_2 }}
                </div>
                <div v-if="props.item.micro_familia_3">
                  ACEROLATINA: {{ props.item.micro_familia_3 }}
                </div>
              </td>
              <td class="text-xs-center">
                {{ props.item.user ? props.item.user.name : "" }}
              </td>
              <td class="text-xs-center">
                <v-icon v-if="props.item.creado === 1" color="green"
                  >check</v-icon
                >
                <v-icon v-else color="red">close</v-icon>
              </td>
              <td class="text-xs-center">
                <v-btn
                  v-if="props.item.creado !== 1"
                  flat
                  icon
                  @click.native="crudDestroy(props.item.id)"
                  color="red"
                  :loading="loadingDel === props.item.id"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-btn
                  flat
                  icon
                  @click.native="crudShow(props.item)"
                  color="orange"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.creado !== 1"
                  flat
                  icon
                  @click.native="crudEdit(props.item)"
                  color="blue"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  v-if="tienePermiso && props.item.creado !== 1"
                  flat
                  icon
                  @click.native="crudConfirm(props.item.id)"
                  color="green"
                  :loading="loadingConfirm === props.item.id"
                >
                  <v-icon>check</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="crudDialog" fullscreen scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{ titulo }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click.stop="crudDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs8>
                <v-layout>
                  <v-flex>
                    <v-switch
                      v-model="d.altaMicro"
                      label="¿Dar de alta en microsiga? AL SELECCIONAR (EL BOTON SE VA A PONER DE COLOR)... VA DAR DE ALTA EL PRODUCTO EN MICROSIGA"
                      @change="altaMicroValidate"
                    ></v-switch>
                  </v-flex>
                  <v-flex>
                    <v-switch
                      v-model="d.web"
                      label="¿Dar de alta en web? AL SELECCIONAR (EL BOTON SE VA A PONER DE COLOR)... VA A DAR DE ALTA LOS PRODUCTOS EN LA WEB"
                    ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <tipo-item-select
                      label="Tipo de producto"
                      v-model="d.item_tipo_id"
                      v-validate="'required'"
                      :error-messages="errores.collect('item_tipo_id')"
                      data-vv-name="item_tipo_id"
                      data-vv-as="Tipo de item"
                      :validator="$validator"
                    ></tipo-item-select>
                  </v-flex>

                  <v-flex>
                    <micro-unidad-select
                      label="Unidad de medida"
                      v-model="d.um"
                      v-validate="'required'"
                      data-vv-name="um"
                      data-vv-as="Unidad de medida"
                      :error-messages="errores.collect('um')"
                    ></micro-unidad-select>
                  </v-flex>
                  <v-flex v-if="d.item_tipo_id === 5">
                    <v-text-field
                      label="Ancho"
                      v-model="d.ancho"
                      :error-messages="errores.collect('ancho')"
                      v-validate="d.item_tipo_id === 5 ? 'required' : ''"
                      data-vv-name="ancho"
                      data-vv-as="Ancho"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-switch
                      v-model="d.lote"
                      label="¿Posee control por lote?"
                    ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex v-if="d.item_tipo_id === 5">
                    <v-text-field
                      label="Código"
                      v-model="d.codigo"
                      maxlength="15"
                      counter
                      :error-messages="errores.collect('codigo')"
                      v-validate="d.item_tipo_id === 5 ? 'required' : ''"
                      data-vv-name="codigo"
                      data-vv-as="Código"
                      @blur="validaCodigo()"
                      @input="getProdSugerencias('codigo', d.codigo)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      label="Descripción"
                      v-model="d.descripcion"
                      maxlength="50"
                      counter
                      :error-messages="errores.collect('descripcion')"
                      v-validate="'required'"
                      data-vv-name="descripcion"
                      data-vv-as="Descripción"
                      @input="getProdSugerencias('desc', d.descripcion)"
                    ></v-text-field>
                    <micro-grupo-select
                      label="Familia"
                      v-model="d.micro_familia_1"
                      empresa="1"
                      :preset="d.micro_familia_1"
                      @change="getNextID(1, d.micro_familia_1)"
                      :error-messages="errores.collect('micro_familia_1')"
                      v-validate="d.micro_store_1 ? 'required' : ''"
                      data-vv-name="micro_familia_1"
                      data-vv-as="Familia Friolatina"
                    ></micro-grupo-select>
                    <v-text-field
                      label="Código"
                      v-model="d.micro_id_1"
                      maxlength="15"
                      counter
                      @change="getProdSugerencias('codigo', d.micro_id_1)"
                      :error-messages="errores.collect('micro_id_1')"
                      v-validate="d.micro_store_1 ? 'required' : ''"
                      data-vv-name="micro_id_1"
                      data-vv-as="Código Friolatina"
                    ></v-text-field>
                    <micro-cta-select
                      label="Cuenta contable"
                      v-model="d.micro_cta_ctble_1"
                      empresa="1"
                      :preset="d.micro_cta_ctble_1"
                    />
                    <micro-cta-select
                      label="Cuenta gastos"
                      v-model="d.micro_cta_gsto_1"
                      empresa="1"
                      :preset="d.micro_cta_gsto_1"
                    />
                    <micro-cta-select
                      label="Cuenta venta"
                      v-model="d.micro_cta_vta"
                      empresa="1"
                      :preset="d.micro_cta_vta"
                    />
                    <empresa-select
                      label="Fabricante"
                      v-model="d.fabric"
                      empresa="1"
                      :preset="d.fabric"
                    />
                    <v-text-field
                      label="Tipo entrada"
                      v-model="d.te"
                    ></v-text-field>
                    <v-text-field
                      label="Tipo salida"
                      v-model="d.ts"
                    ></v-text-field>                                        
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs4>
                <v-progress-linear
                  :indeterminate="true"
                  :active="loadingSuggest"
                ></v-progress-linear>
                <v-toolbar-title>{{ existentes }}</v-toolbar-title>
                <div class="scroll-div">
                  <v-list dense three-line>
                    <template v-for="i in prodSuggest">
                      <v-list-tile @click="setValores(i)">
                        <v-list-tile-avatar>
                          <img :src="'./img/iso-' + i.emp + '.svg'" />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          {{ i.cod }} | {{ i.desc }}
                          <v-list-tile-sub-title
                            >Familia: {{ i.flia }} |
                            {{ i.fliaTxt }}</v-list-tile-sub-title
                          >
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                    </template>
                  </v-list>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" dark v-if="oper === 'add'" @click="crudStore"
            >Agregar</v-btn
          >
          <v-btn color="green" dark v-if="oper === 'edit'" @click="crudUpdate"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import itemSelect from '../../../components/ItemSelect';
import microUnidadSelect from '../../../components/MicroUnidadSelect';
import EmpresaSelect from '../../../components/EmpresaSelect';
import microGrupoSelect from '../../../components/MicroGrupoSelect';
import mixinItemSol from '../../../mixins/items_solicitud';
import mixinItem from '../../../mixins/items';
import TipoItemSelect from '../../../components/TipoItemSelect';
import MicroCtaSelect from '../../../components/MicroCtaSelect';
import { mapActions } from 'vuex';

function initialData() {
  return {
    altaMicro: false,
    descripcion: '',
    um: '',
    item_tipo_id: '',
    ancho: '',
    lote: false,
    codigo: '',
    micro_id_1: '',
    micro_id_2: '',
    micro_id_3: '',
    micro_familia_1: '',
    micro_familia_2: '',
    micro_familia_3: '',
    micro_cta_gsto_1: '',
    micro_cta_gsto_2: '',
    micro_cta_gsto_3: '',
    micro_cta_ctble_1: '',
    micro_cta_ctble_2: '',
    micro_cta_ctble_3: '',
    micro_cta_vta: '',
    user_id: '',
    creado: '',
    micro_store_1: true,
    micro_store_2: true,
    micro_store_3: true,
    web: true,
    debounce: null,
    fabric:'',
    ts:'',
    te:''
  }
}

export default {
  name: "solicitud",
  mixins: [mixinItemSol, mixinItem],
  components: { itemSelect, TipoItemSelect, microUnidadSelect, microGrupoSelect, MicroCtaSelect, EmpresaSelect },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      tienePermiso: false,
      search: '',
      totalItems: 0,
      loading: false,
      d: initialData(),
      headers: [
        { text: 'ID', value: 'id', align: 'center' },
        { text: 'Tipo', value: 'item_tipos_id', align: 'center' },
        { text: 'Descripción', value: 'descripcion', align: 'center' },
        { text: 'UM', value: 'um', align: 'center' },
        { text: 'Ancho', value: 'ancho', align: 'center' },
        { text: 'Código', align: 'center' },
        { text: 'Familia', align: 'center' },
        { text: 'Usuario', value: 'user_id', align: 'center' },
        { text: 'Creado', value: 'creado', align: 'center' },
      ],
      items: [],
      pag: {
        sortBy: 'id',
        descending: true
      },
      filtro: {
        tipo: ''
      },
      rows: [10, 20, 30, { text: 'Todo', value: -1 }],
      crudDialog: false,
      crudloading: false,
      loadingDel: -1,
      loadingConfirm: -1,
      oper: 'add',
      item_tipos: [],
      item: {},
      prodSuggest: [],
      loadingSuggest: false,
      existentes: ''
    }
  },
  computed: {
    titulo() {
      if (this.oper === 'add') {
        return 'Agregar solicitud';
      } else if (this.oper === 'edit') {
        return 'Editar solicitud';
      } else {
        return 'Mostrando solicitud';
      }
    },
    titLabel() {
      return (this.d.altaMicro) ? '¿Guardar en esta empresa?' : '¿Vincular a esta empresa?'
    }
  },
  watch: {
    pag: {
      handler() {
        this.getData();
      },
      deep: true,
      immediate: false
    }
  },
  mounted() {
    this.itemSolicitudPermiso(r => {
      this.tienePermiso = r;
    }, err => console.error(err));
    this.getData();
    this.itemTipos(r => {
      this.item_tipos = r;
    }, err => console.error(err));
  },
  methods: {
    ...mapActions('notif', ['msjShow']),
    ...mapActions('progreso', ['progresoShow', 'progresoHide', 'progresoPorcent']),
    setValores(i) {
      if (this.d.altaMicro) {
        this.getNextID(i.emp, i.flia);
      } else {
        this.d['micro_id_' + i.emp] = i.cod;
        this.d.descripcion = i.desc;
        this.d.codigo = i.cod;
      }
      this.d['micro_familia_' + i.emp] = i.flia;
      this.d['micro_cta_gsto_' + i.emp] = i.ctaGasto;
      this.d['micro_cta_ctble_' + i.emp] = i.ctaCtble;
      this.d.lote = (i.rastro === 'L')
    },
    altaMicroValidate() {
      this.d.micro_store_1 = (this.d.altaMicro !== false);
      this.d.micro_store_2 = (this.d.altaMicro !== false);
      this.d.micro_store_3 = (this.d.altaMicro !== false);
      this.d.web = this.d.altaMicro;
    },
    getNextID(empresa, grupo) {
      if (this.d.item_tipo_id === 5) {
        return false;
      }
      this.itemMicroNextId({ empresa_id: empresa, grupo: grupo }, r => {
        this.d['micro_id_' + empresa] = r;
      })
    },
    validaCodigo() {
      if (this.d.item_tipo_id === 5) {
        this.d.micro_id_1 = this.d.codigo;
        this.d.micro_id_2 = this.d.codigo;
        this.d.micro_id_3 = this.d.codigo;
      }
    },
    getProdSugerencias(tipo, q) {
      if (!q || q.length < 3) {
        return false;
      }
      this.existentes = (tipo === 'codigo') ? 'Existentes por codigo' : 'Existentes por descripción';
      this.loadingSuggest = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.itemMicroProdSugerencias({ q: q, tipo: tipo }, r => {
          this.prodSuggest = r;
          this.loadingSuggest = false;
        }, err => {
          this.loadingSuggest = false;
        })
      }, 700);
    },
    crudAdd() {
      this.oper = 'add';
      this.d = initialData();
      this.crudDialog = true;
    },
    crudShow(item) {
      this.d = initialData();
      this.oper = 'show';
      this.d = item;
      this.crudDialog = true;
    },
    crudEdit(item) {
      this.d = initialData();
      this.oper = 'edit';
      this.d = item;
      this.crudDialog = true;
    },
    crudStore() {
      this.$validator.validateAll()
        .then(r => {
          if (!r) {
            let errores = [];
            this.$validator.errors.items.forEach(r => {
              errores.push(r.msg)
            });
            this.msjShow({ tipo: 2, txt: 'Errores de validación', errores: errores });
            return false;
          }
          this.crudloading = true;
          this.itemSolicitudStore(this.d, r => {
            this.msjShow(r);
            this.getData();
            this.crudDialog = false;
          }, err => {
            this.msjShow({ tipo: 2, txt: 'Error al guardar registro' });
            this.crudloading = false;
          })
        });

    },
    crudUpdate() {
      this.$validator.validateAll()
        .then(r => {
          if (!r) {
            this.msjShow({ tipo: 2, txt: 'Errores de validacion' });
            return false;
          }
          this.crudloading = true;
          this.itemSolicitudUpdate(this.d.id, this.d, r => {
            this.msjShow(r);
            this.getData();
            this.crudDialog = false;
          }, err => {
            this.msjShow({ tipo: 2, txt: 'Error al guardar registro' });
            this.crudloading = false;
          })
        });

    },
    crudDestroy(id) {
      this.loadingDel = id;
      this.itemSolicitudDestroy(id, r => {
        this.msjShow(r);
        this.loadingDel = -1;
        this.getData();
      }, err => {
        this.msjShow({ tipo: 2, txt: 'Error al eliminar registro' });
        this.loadingDel = -1;
      })
    },
    crudConfirm(id) {
      this.loadingConfirm = id;
      this.itemSolicitudConfirmar(id, r => {
        this.msjShow(r);
        this.loadingConfirm = -1;
        this.getData();
      }, err => {
        this.msjShow({ tipo: 2, txt: 'Error al guardar registro' });
        this.loadingConfirm = -1;
      })
    },
    getData() {
      this.loading = true;
      this.pag.search = this.search;
      this.pag.filtro = this.filtro;
      this.itemSolicitudIndex(this.pag, r => {
        this.items = r.data;
        this.totalItems = r.total;
        this.loading = false;
      }, err => {
        console.log(err);
        this.loading = false;
      });
    },
    update(item) {
      this.itemUpdate(item.id, item, r => {
        this.msjShow(r);
        this.getData()
      }, err => {
        this.msjShow({ tipo: 2, txt: 'Error al guardar' });
      })
    }
  }
}
</script>

<style scoped>
div.scroll-div {
  overflow-y: auto;
  max-height: 500px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/archivo/productos/solicitud.vue